import React, { useState, useEffect } from "react";
import Modal from "../UI/Modal";
import ConfirmationDialog from "../UI/ConfirmationDialog";
import Button from "../UI/Button";
import { ToastNotification } from "../UI/ToastNotification";
import {
  acceptUserInterestRequest,
  declineUserInterestRequest,
  acceptNewStudentRequest,
  declineNewStudentRequest,
} from "../../requests/users";

export default function AcceptNewStudent({
  id,
  type,
  userId,
  onAccept,
  onDecline,
}) {
  const [confirmAction, setConfirmAction] = useState(null);

  const acceptRequest =
    type === "interest" ? acceptUserInterestRequest : acceptNewStudentRequest;
  const declineRequest =
    type === "interest" ? declineUserInterestRequest : declineNewStudentRequest;

  const handleAccept = async () => {
    const res = await acceptRequest({ userId, id });
    if (res.status === 200) {
      ToastNotification("success", "Student accepted successfully");
      setConfirmAction(null);
      onAccept();
    } else {
      ToastNotification.error(res.data.message);
    }
  };

  const handleDecline = async () => {
    const res = await declineRequest({ userId, id });
    if (res.status === 200) {
      ToastNotification("success", "Student declined");
      setConfirmAction(null);
      onDecline();
    } else {
      ToastNotification.error(res.data.message);
    }
  };

  const handleClick = (e, action) => {
    e.preventDefault();
    e.stopPropagation();
    setConfirmAction(action);
  };

  useEffect(() => {
    setConfirmAction(null);
  }, [id]);

  return (
    <>
      <div className="flex justify-end gap-1">
        <Button
          onClick={(e) => handleClick(e, "accept")}
          variant="primary-outline"
          classNames="m-0 p-0 h-[28px] text-sm px-2"
        >
          Accept
        </Button>
        <Button
          onClick={(e) => handleClick(e, "decline")}
          variant="primary-outline"
          classNames="m-0 p-0 h-[28px] text-sm px-2"
        >
          Decline
        </Button>
      </div>

      <Modal dark open={Boolean(confirmAction)} setOpen={setConfirmAction}>
        <ConfirmationDialog
          closeModal={() => setConfirmAction(null)}
          label={`Are you sure you want to ${(confirmAction || "").toUpperCase()} this student?`}
          confirmAction={() => {
            if (confirmAction === "accept") {
              handleAccept();
            } else if (confirmAction === "decline") {
              handleDecline();
            }
          }}
        />
      </Modal>
    </>
  );
}
